"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var Drawer_1 = __importDefault(require("@mui/material/Drawer"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var ListItem_1 = __importDefault(require("@mui/material/ListItem"));
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var FeedbackOutlined_1 = __importDefault(require("@mui/icons-material/FeedbackOutlined"));
var ChevronLeft_1 = __importDefault(require("@mui/icons-material/ChevronLeft"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var flavor_config_1 = require("../../flavor-config");
var SidebarItem_1 = require("./SidebarItem");
var Logo_1 = __importDefault(require("../Logo"));
var ToolbarButton_1 = __importDefault(require("../Base/ToolbarButton"));
var realcity_logo_big_svg_1 = __importDefault(require("../../../images/realcity_logo_big.svg"));
var SidebarBody_1 = __importDefault(require("./SidebarBody"));
var logo = (0, flavor_config_1.requireWFFlavorAsset)('images/logo_small_2.png');
var useStyles = (0, makeStyles_1.default)({
    sidebarHeader: {
        alignItems: 'center',
        display: 'flex',
        height: 56,
    },
    container: {
        position: 'absolute',
        right: 0,
        left: 0,
        bottom: 0,
        top: 0,
        display: 'flex',
        flexDirection: 'column',
    },
    paper: {
        width: 360,
        position: 'absolute',
        height: 'inherit',
        bottom: 0,
        right: 0,
    },
});
var TemporarySidebar = function (props) {
    var appName = props.appName, appVersion = props.appVersion, useFeedback = props.useFeedback, children = props.children, onClose = props.onClose, rest = __rest(props, ["appName", "appVersion", "useFeedback", "children", "onClose"]);
    var classes = useStyles();
    return (react_1.default.createElement(Drawer_1.default, __assign({ variant: "temporary", onClose: onClose, classes: { paper: classes.paper } }, rest),
        react_1.default.createElement("div", { onClick: onClose, className: classes.container },
            react_1.default.createElement("div", { className: classes.sidebarHeader },
                react_1.default.createElement(ToolbarButton_1.default, null,
                    react_1.default.createElement(ChevronLeft_1.default, null)),
                react_1.default.createElement(Logo_1.default, { src: logo }),
                react_1.default.createElement(Typography_1.default, { color: "primary", variant: "h5" }, appName)),
            react_1.default.createElement(SidebarBody_1.default, { logo: realcity_logo_big_svg_1.default }, children),
            useFeedback && (react_1.default.createElement(SidebarItem_1.SidebarItem, { sx: { marginTop: '12px' }, icon: FeedbackOutlined_1.default, text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "feedback" }), path: "/feedback" })),
            react_1.default.createElement(ListItem_1.default, { disableGutters: true },
                react_1.default.createElement(ListItemText_1.default, { primary: "realCity ".concat(appName, " ").concat(appVersion) })))));
};
exports.default = TemporarySidebar;
